module.exports = __webpack_public_path__ + "b269803b7b88a9e2a4657e01a938466c.png";